let localData = null;

export const getLocalData = async () => {
  if (!localData) {
    try {
      // Fetch data.json from the public folder (served at root /)
      const response = await fetch('/data.json');
      const jsonData = await response.json();
      // Keep a mutable local copy in memory
      localData = JSON.parse(JSON.stringify(jsonData));
    } catch (err) {
      console.error("Failed to fetch data:", err);
    }
  }
  return localData;
};
